import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { collectUniqueValues, findMaxTerm } from "../../helpers/getAllPeriodsSums";
import { filterTariffs } from "../../helpers/filterTariffs";
import { CalcRequestPlace, ChangeSlider } from "../../types/enums";
import { pickTariff } from "../../helpers/pickTarriff";
import { useDispatch, useSelector } from "react-redux";
import { selectTariffs } from "../../redux/selectors/tariffs";
import { selectRequestPlace } from "../../redux/selectors/requestPlace";
import { setSumTerm } from "../../redux/slices/selectedSumTerm";
import { initialTerm, PaymentVariants, JustZeroConfig } from "../../types/constants";
export var BaseCalc = function (_a) {
    var Layout = _a.Layout, esiaLink = _a.esiaLink, context = _a.context, tarifDocumentUrl = _a.tarifDocumentUrl;
    var tariffs = useSelector(selectTariffs).tariffs;
    var _b = useState({ periods: [], sumRange: [], daysPay: [] }), values = _b[0], setValues = _b[1];
    var _c = useState(undefined), selectedDays = _c[0], setSelectedDays = _c[1];
    var _d = useState(PaymentVariants.EQUAL_PAYMENTS), selectedPaymentVariant = _d[0], setSelectedPaymentVariant = _d[1];
    var _e = useState("sum"), lastChanged = _e[0], setLastChanged = _e[1];
    var _f = useState(0), selectedSum = _f[0], setSelectedSum = _f[1];
    var _g = useState(initialTerm), selectedPeriod = _g[0], setSelectedPeriod = _g[1];
    var _h = useState(0), selectedLoanType = _h[0], setSelectedLoanType = _h[1];
    var _j = useState(false), canSetDatePays = _j[0], setCanSetDatePays = _j[1];
    var _k = useState(""), error = _k[0], setError = _k[1];
    var dispatch = useDispatch();
    var isBezProc = document.referrer.includes("/zaimy/bez-procentov/");
    useEffect(function () {
        setLastChanged("sum");
    }, [tariffs]);
    useEffect(function () {
        setValues(collectUniqueValues(tariffs));
    }, [tariffs]);
    useEffect(function () {
        if (selectedLoanType === 1) {
            var filteredTariffs = filterTariffs(tariffs, {
                period: selectedPeriod,
                sum: selectedSum,
                changeSlider: ChangeSlider.CUSTOM,
                variant: selectedLoanType === 1 ? selectedPaymentVariant : null,
            });
            if (filteredTariffs.length > 0) {
                var pickedTariff = pickTariff(filteredTariffs, selectedSum);
                setSelectedPeriod({ value: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods[pickedTariff.periods.length - 1]) || 0, vr: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.vr) || 0 });
                setValues(collectUniqueValues(filteredTariffs));
            }
            else {
                // Логика при отсутствии подходящих тарифов
                var maxSum = Math.max.apply(Math, values.sumRange);
                var maxPeriod = findMaxTerm(values.periods);
                setSelectedSum(maxSum);
                setSelectedPeriod(maxPeriod);
                setError("Не удалось найти подходящий тариф");
            }
        }
    }, [tariffs, selectedLoanType]);
    useEffect(function () {
        setSelectedSum(isBezProc ? JustZeroConfig.MAX_SUM : function () { return Math.max.apply(Math, values.sumRange); });
        if (!selectedPeriod.value) {
            setSelectedPeriod(function () { return findMaxTerm(values.periods); });
        }
    }, [tariffs, values]);
    useEffect(function () {
        // Проверяем возможность установки дат платежей на основе UseListDatPlat
        if (tariffs.length > 0) {
            var selectedTariff = tariffs.find(function (tariff) {
                return tariff.periods.includes(selectedPeriod.value) &&
                    tariff.maxSum >= selectedSum;
            });
            var canSetDates = (selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.useListDatPlat) === -1;
            setCanSetDatePays(canSetDates);
        }
    }, [selectedPeriod, selectedSum, tariffs]);
    var requestPlace = useSelector(selectRequestPlace).requestPlace;
    useEffect(function () {
        if (requestPlace === CalcRequestPlace.STEP232) {
            setSelectedPaymentVariant(PaymentVariants.EQUAL_PAYMENTS);
        }
    }, [requestPlace]);
    useEffect(function () {
        setError("");
        if (lastChanged === 'sum') {
            // Пользователь изменил сумму, необходимо проверить существование тарифа с текущим сроком
            var tariffsWithSumAndPeriod = filterTariffs(tariffs, {
                period: selectedPeriod,
                sum: selectedSum,
                variant: selectedLoanType === 1 ? selectedPaymentVariant : null,
            });
            if (tariffsWithSumAndPeriod.length > 0) {
                // Найден тариф с выбранной суммой и сроком
                var pickedTariff = pickTariff(tariffsWithSumAndPeriod, selectedSum);
                if (!(pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods.includes(selectedPeriod.value))) {
                    setSelectedPeriod({ value: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods[pickedTariff.periods.length - 1]) || 0, vr: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.vr) || 0 });
                }
            }
            else {
                // Нет тарифа с выбранной суммой и текущим сроком
                // Найти все тарифы с выбранной суммой
                var tariffsWithSum = filterTariffs(tariffs, {
                    period: selectedPeriod,
                    sum: selectedSum,
                    changeSlider: ChangeSlider.SUM,
                    variant: selectedLoanType === 1 ? selectedPaymentVariant : null
                });
                if (tariffsWithSum.length > 0) {
                    //Если тариф найден, но у него не совпадает выбранный срок, то выставляем максимальный срок по найденному тарифу
                    var pickedTariff = pickTariff(tariffsWithSum, selectedSum);
                    if (!(pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods.includes(selectedPeriod.value))) {
                        setSelectedPeriod({ value: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods[pickedTariff.periods.length - 1]) || 0, vr: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.vr) || 0 });
                    }
                }
                else {
                    // Нет тарифов с выбранной суммой, установить максимально допустимую сумму и период
                    var maxSum = Math.max.apply(Math, values.sumRange);
                    var maxPeriod = findMaxTerm(values.periods);
                    setSelectedSum(maxSum);
                    setSelectedPeriod(maxPeriod);
                    // Найти тариф с максимальной суммой и периодом
                    var tariffsWithMaxSumAndMaxPeriod = filterTariffs(tariffs, {
                        period: maxPeriod,
                        sum: maxSum,
                        variant: selectedLoanType === 1 ? selectedPaymentVariant : null
                    });
                    if (tariffsWithMaxSumAndMaxPeriod.length > 0) {
                        pickTariff(tariffsWithMaxSumAndMaxPeriod, maxSum);
                    }
                    else {
                        setError("Не удалось найти подходящий тариф");
                    }
                }
            }
            // Сбрасываем флаг изменения
            setLastChanged(null);
        }
        else if (lastChanged === 'period') {
            // Пользователь изменил срок, необходимо проверить существование тарифа с текущей суммой
            var tariffsWithSumAndPeriod = filterTariffs(tariffs, {
                period: selectedPeriod,
                sum: selectedSum,
                variant: selectedLoanType === 1 ? selectedPaymentVariant : null
            });
            if (tariffsWithSumAndPeriod.length > 0) {
                // Найден тариф с выбранной суммой и сроком
                pickTariff(tariffsWithSumAndPeriod, selectedSum);
            }
            else {
                // Нет тарифа с выбранной суммой и текущим сроком
                // Найти все тарифы с выбранным сроком
                var tariffsWithPeriod = filterTariffs(tariffs, {
                    period: selectedPeriod,
                    sum: selectedSum, // Игнорируем сумму
                    changeSlider: ChangeSlider.PERIOD,
                    variant: selectedLoanType === 1 ? selectedPaymentVariant : null
                });
                if (tariffsWithPeriod.length > 0) {
                    // Выбрать тариф с максимальной суммой среди тарифов с выбранным сроком
                    var pickedTariff = pickTariff(tariffsWithPeriod, selectedSum);
                    if (pickedTariff) {
                        setSelectedSum(pickedTariff.maxSum);
                    }
                }
                else {
                    // Нет тарифов с выбранным сроком, установить максимально допустимую сумму и период
                    var maxSum = Math.max.apply(Math, values.sumRange);
                    var maxPeriod = findMaxTerm(values.periods);
                    setSelectedSum(maxSum);
                    setSelectedPeriod(maxPeriod);
                    // Найти тариф с максимальной суммой и периодом
                    var tariffsWithMaxSumAndMaxPeriod = filterTariffs(tariffs, {
                        period: maxPeriod,
                        sum: maxSum,
                        variant: selectedLoanType === 1 ? selectedPaymentVariant : null
                    });
                    if (tariffsWithMaxSumAndMaxPeriod.length > 0) {
                        pickTariff(tariffsWithMaxSumAndMaxPeriod, maxSum);
                    }
                    else {
                        setError("Не удалось найти подходящий тариф");
                    }
                }
            }
            // Сбрасываем флаг изменения
            setLastChanged(null);
        }
    }, [lastChanged, selectedSum, selectedPeriod, tariffs, values.sumRange, values.periods]);
    useEffect(function () {
        setError("");
        if (lastChanged === 'variant') {
            var filteredTariffs = filterTariffs(tariffs, {
                period: selectedPeriod,
                sum: selectedSum,
                changeSlider: ChangeSlider.CUSTOM,
                variant: selectedLoanType === 1 ? selectedPaymentVariant : null,
            });
            if (filteredTariffs.length > 0) {
                var pickedTariff = pickTariff(filteredTariffs, selectedSum);
                setSelectedPeriod({ value: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.periods[pickedTariff.periods.length - 1]) || 0, vr: (pickedTariff === null || pickedTariff === void 0 ? void 0 : pickedTariff.vr) || 0 });
                setValues(collectUniqueValues(filteredTariffs));
            }
            else {
                // Логика при отсутствии подходящих тарифов
                var maxSum = Math.max.apply(Math, values.sumRange);
                var maxPeriod = findMaxTerm(values.periods);
                setSelectedSum(maxSum);
                setSelectedPeriod(maxPeriod);
                setError("Не удалось найти подходящий тариф");
            }
            // Сброс флага изменения
            setLastChanged(null);
        }
    }, [selectedSum, selectedPeriod, tariffs, lastChanged, selectedPaymentVariant]);
    useEffect(function () {
        if (selectedSum && selectedPeriod) {
            dispatch(setSumTerm({ sum: selectedSum, term: selectedPeriod }));
        }
    }, [selectedSum, selectedPeriod]);
    // Обработчик изменения суммы
    var handleSumChange = function (newSum) {
        setSelectedSum(newSum);
        setLastChanged('sum');
    };
    // Обработчик изменения периода
    var handlePeriodChange = function (newPeriod) {
        setSelectedPeriod(newPeriod);
        setLastChanged('period');
    };
    var handlePaymentVariantChange = function (newVariant) {
        setSelectedPaymentVariant(newVariant);
        setLastChanged('variant');
    };
    // Обработчик изменения дней
    var handleDaysChange = function (index) {
        setSelectedDays(index);
    };
    return (_jsxs("div", { children: [tariffs.length > 0 && (_jsx(_Fragment, { children: Layout &&
                    _jsx(Layout, { values: values, selectedSum: selectedSum, selectedPeriod: selectedPeriod, selectedPaymentVariant: selectedPaymentVariant, onSumChange: handleSumChange, onPeriodChange: handlePeriodChange, onPaymentVariantChange: handlePaymentVariantChange, onDaysChange: handleDaysChange, selectedDays: selectedDays, esiaLink: esiaLink, loanType: selectedLoanType, setLoanType: setSelectedLoanType, context: context, tarifDocumentUrl: tarifDocumentUrl, canSetDatePays: canSetDatePays }) })), error && _jsx("div", { className: "calc-error", children: error })] }));
};
